import xIcon from 'assets/svg/close-24px.svg'
import { useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 400px;
  background: #0e1218;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.backgroundOutline};
  padding: 10px 20px;
  margin: 10px;
  position: relative;
`

const Button = styled.div`
  cursor: pointer;
  width: 24px;
  position: absolute;
  top: 5px;
  right: 5px;
`

const Text = styled.div`
  font-size: 14px;
`

export default function Banner() {
  const [show, setShow] = useState(true)

  if (!show) return null

  return (
    <div style={{ position: 'absolute', top: 72, zIndex: 1000 }}>
      <Wrapper>
        <Text>
          Attention everyone: Please be aware that ICE is the only token representing Popsicle/Wagmi, and it is not
          available on zkSync. You can find the ICE token on Ethereum mainnet, Fantom, BSC, and Polygon networks.
          Remember to stay alert and be careful to avoid scams.
          {/* <p>
            <b style={{ color: 'red' }}>
              Due to outage in subgraph wagmi services may be disturbed including analytics and informational graphics.
            </b>
          </p> */}
        </Text>
        <Button onClick={() => setShow(false)}>
          <img alt="close" src={xIcon} />
        </Button>
      </Wrapper>
    </div>
  )
}
